import { render } from "./OrgChart.vue?vue&type=template&id=61f72424&scoped=true"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"

import "./OrgChart.vue?vue&type=style&index=0&id=61f72424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f72424"]])

export default __exports__